


































import Component from 'vue-class-component';
import BaseComponent from '../BaseComponent';
import Dropdown from '@/components/Dropdown/Dropdown.vue';

@Component({
  components: {
    Dropdown
  },
  props: {
    statValues: Object,
    filterValues: Array
  },
})
export default class ProjectStatistics extends BaseComponent {
  filterValue = null;

  emitShowProject(): void {
    this.$emit('showProject');
  }

  emitFilterValue(): void {
    this.$emit('filterChanged', this.filterValue);
  }
}
